import React from 'react';
import '../../css/cyder/form/mandatory-star.css';

const MandatoryStar = ({ bold }) => <span className={`mandatory-star ${bold ? 'text-bold' : ''}`}> * </span>;

export default MandatoryStar;
